export default "__VITE_ASSET__79d585ac__"